module.exports = __webpack_public_path__ + "c69ac1bf334f7c5ae2c29af4535f5bac.png";